import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, Clock } from "lucide-react";

export default function PaymentMPResult() {
  const [params] = useSearchParams();
  const id = params.get("preapproval_id");
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!id) { setState("pending"); return; }
    let n = 0, timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/mercadopago/status/${id}`);
        if (data.payment_status === "paid") { setState("paid"); refresh?.(); return; }
      } catch { /* retry */ }
      if (++n >= 8) { setState("pending"); return; }
      timer = setTimeout(poll, 2500);
    };
    poll();
    return () => clearTimeout(timer);
  }, [id, refresh]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-mp-result-page">
      {state === "checking" && (<><Loader2 className="w-12 h-12 mx-auto text-indigo-400 animate-spin" /><h1 className="font-display text-3xl font-bold text-white mt-6">Confirmando assinatura…</h1></>)}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-14 h-14 mx-auto text-teal-400" />
          <h1 className="font-display text-3xl font-bold text-white mt-6" data-testid="payment-mp-success-title">Assinatura ativada!</h1>
          <p className="text-slate-400 mt-2">Pagamento via Mercado Pago confirmado. Plano Essencial ativo.</p>
        </>
      )}
      {state === "pending" && (
        <>
          <Clock className="w-14 h-14 mx-auto text-amber-400" />
          <h1 className="font-display text-3xl font-bold text-white mt-6">Aguardando confirmação</h1>
          <p className="text-slate-400 mt-2">O Mercado Pago ainda está processando. Assim que confirmado, sua assinatura será ativada automaticamente.</p>
        </>
      )}
      <Button asChild className="mt-8 bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="payment-mp-dashboard">
        <Link to="/gestor">Ir para o painel</Link>
      </Button>
    </div>
  );
}
